export {};

const prevArrow = NLMK.generateSlickArrow('left', 'prev');
const nextArrow = NLMK.generateSlickArrow('right', 'next');

NLMK.initTitledSlide = init;

$(init);

function init() {
    $('.titled-slider').each(eachBlock);

    accordionShowedListen();
}

function eachBlock(blockIndex, Block) {
    const $block = $(Block);
    const $slider = $block.find('.titled-slider__list');
    const isDocSlider = $block.hasClass('js-titled-slider-doc');
    const isRtl = $block.hasClass('js-titled-slider-rtl');

    const $arrowsTopContainer = $block.find('.titled-slider__arrows--top');
    const $arrowsBottomContainer = $block.find('.titled-slider__arrows--bottom');
    const $arrowsContainers = $block.find('.titled-slider__arrows--top, .titled-slider__arrows--bottom');

    const $pagination = $block.find('.titled-slider__pagination');
    const $currentIndex = $pagination.find('.titled-slider__current-index');
    const $totalSlides = $pagination.find('.titled-slider__total-slides');

    const $arrowNext = $(nextArrow);
    const $arrowPrev = $(prevArrow);

    const $arrows = $(document.createDocumentFragment());

    let SlickApi;

    $arrows.append($arrowPrev).append($arrowNext);

    $arrowsTopContainer.append($arrows.clone());
    $arrowsBottomContainer.append($arrows.clone());

    const $nextArrows = $arrowsTopContainer.find('.slick-next').add($arrowsBottomContainer.find('.slick-next'));
    const $prevArrows = $arrowsTopContainer.find('.slick-prev').add($arrowsBottomContainer.find('.slick-prev'));
    const infinite = $slider.data('infinite');
    const mVariableWidth = $slider.data('mobile-variable-width');

    const options = {
        arrows: false,
        dots: false,
        infinite: typeof infinite !== 'undefined' && !!infinite,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 0,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    variableWidth: typeof mVariableWidth !== 'undefined' && !!mVariableWidth,
                },
            },
            {
                breakpoint: isDocSlider ? 319 : 529,
                settings: {
                    variableWidth: false,
                    slidesToShow: 2,
                    slidesToScroll: 2,
                },
            },
            {
                breakpoint: NLMK.mediaQueries.verticalTablet.min - 1,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                },
            },
        ],
    };

    if (isDocSlider) {
        options.responsive.push({
            breakpoint: 1439,
            settings: {
                variableWidth: false,
                slidesToShow: 5,
                slidesToScroll: 5,
            },
        });
    }

    $slider
        .on('init', onSlickInit)
        .on('afterChange', afterChange)
        .on('setPosition', (ev, slick) => paginationToogle(slick, $pagination, $arrowsContainers))
        .slick(options);

    function afterChange(ev, Api, currentSlide) {
        $currentIndex.text(currentSlide + 1);

        toggleArrowsAccessible({ Api, currentSlide });
    }

    function onSlickInit(ev, Api) {
        if (typeof isRtl !== 'undefined' && !!isRtl) {  //Отображаем последний слайд. initialSlide давал баг с прокруткой на низких разрешениях, в случае если кол-во слайдов не кратно slidesToScroll.
            var prevSpeed = Api.slickGetOption('speed');
            Api.slickSetOption('speed', 0);
            Api.slickGoTo(Api.$slides.length);
            Api.slickSetOption('speed', prevSpeed);
        }

        SlickApi = Api;
        paginationToogle(Api, $pagination, $arrowsContainers);

        $block
            .on('click', '.slick-next', (evt) => {
                Api.next();

                evt.preventDefault();
            })
            .on('click', '.slick-prev', (evt) => {
                Api.prev();

                evt.preventDefault();
            });

        $currentIndex.text(Api.currentSlide + 1);
        $totalSlides.text(Api.$slides.length);

        toggleArrowsAccessible();
    }

    function toggleArrowsAccessible(slick) {
        const toShow = SlickApi.breakpointSettings[SlickApi.activeBreakpoint].slidesToShow;

        const isFirstActive = 0 === SlickApi.currentSlide;
        const isLastActive = SlickApi.$slides.length - (toShow > 1 ? toShow : 1) === SlickApi.currentSlide;

        $prevArrows.toggleClass('no-accessible', isFirstActive);
        $nextArrows.toggleClass('no-accessible', isLastActive);

        if (slick) {
            const currInd = slick.currentSlide;
            const breakpointSettings = slick.Api.breakpointSettings[slick.Api.activeBreakpoint];

            if (currInd + breakpointSettings.slidesToShow >= slick.Api.$slides.length) {
                $nextArrows.addClass('no-accessible');
            } else {
                $nextArrows.removeClass('no-accessible');
            }
        }
    }
}

function accordionShowedListen() {
    $('body').on('accordion:showed', function(e, $sliders) {
        $sliders.each(function(idx, item) {
            const $item = $(item);
            if ($item.hasClass('slider-gone-to')) {
                return;
            }
            $item.slick('refresh');
        });

        // TODO: 300ms speed slick
        setTimeout(() => {
            $sliders.css('opacity', '1');
        }, 500);
        $sliders.addClass('slider-gone-to');
    });
}

function paginationToogle(Slick, $pagination, $arrowsContainers) {
    const slidesToShow = Slick.options.slidesToShow;
    const slidesCount = Slick.$slides.length;

    if (slidesCount <= slidesToShow) {
        $pagination.fadeOut(0);
        $arrowsContainers.fadeOut(0);
    } else {
        $pagination.fadeIn();
        $arrowsContainers.fadeIn(0);
    }
}



// WEBPACK FOOTER //
// ./js/main/module/sliders/titled.js